import { Doughnut } from "react-chartjs-2";

import { SENTIMENT } from "@/constants";
import { CHART_SENTIMENT_COLORS } from "@/utils";

import { BaseWidget } from "./BaseWidget";
import { eventPropsForPie, pieOptions } from "./chart_options";
import { showOneDecimalPlace, sumArray } from "./helpers";

const hasData = (data) =>
  data && data.map((d) => (d.sentiment || []).length).reduce(sumArray, 0) > 0;

const SentimentPieWidget = (props) => {
  const labels = [];
  const datasets = [];

  if (hasData(props.data)) {
    const VALUE_INDEX = 1,
      POSITIVE_INDEX = 0,
      NEGATIVE_INDEX = 1,
      NEUTRAL_INDEX = 2,
      VERY_POSITIVE_INDEX = 3,
      VERY_NEGATIVE_INDEX = 4;

    let totalPos = 0,
      totalNeg = 0,
      totalNeu = 0,
      totalVeryPos = 0,
      totalVeryNeg = 0;

    const sumValuesWithIndex = (index) => {
      return (total, item) => total + Math.abs(item[VALUE_INDEX][index]);
    };

    props.data.forEach((reportData) => {
      const sentimentData = reportData["sentiment"] || [];

      totalPos += sentimentData.reduce(sumValuesWithIndex(POSITIVE_INDEX), 0);
      totalNeg += sentimentData.reduce(sumValuesWithIndex(NEGATIVE_INDEX), 0);
      totalNeu += sentimentData.reduce(sumValuesWithIndex(NEUTRAL_INDEX), 0);
      totalVeryPos += sentimentData.reduce(
        sumValuesWithIndex(VERY_POSITIVE_INDEX),
        0
      );
      totalVeryNeg += sentimentData.reduce(
        sumValuesWithIndex(VERY_NEGATIVE_INDEX),
        0
      );
    });

    const totals = totalPos + totalNeg + totalNeu + totalVeryPos + totalVeryNeg,
      percentPos = showOneDecimalPlace(totalPos, totals),
      percentNeg = showOneDecimalPlace(totalNeg, totals),
      percentNeu = showOneDecimalPlace(totalNeu, totals),
      percentVeryPos = showOneDecimalPlace(totalVeryPos, totals),
      percentVeryNeg = showOneDecimalPlace(totalVeryNeg, totals);

    labels.push(
      L.CUSTOMERS_SENTIMENT_GRAPH_POSITIVE,
      L.CUSTOMERS_SENTIMENT_GRAPH_NEGATIVE,
      L.CUSTOMERS_SENTIMENT_GRAPH_NEUTRAL,
      L.CUSTOMERS_SENTIMENT_GRAPH_VERY_POSITIVE,
      L.CUSTOMERS_SENTIMENT_GRAPH_VERY_NEGATIVE
    );

    datasets.push({
      data: [
        percentPos,
        percentNeg,
        percentNeu,
        percentVeryPos,
        percentVeryNeg,
      ],
      backgroundColor: [
        CHART_SENTIMENT_COLORS[SENTIMENT.POSITIVE],
        CHART_SENTIMENT_COLORS[SENTIMENT.NEGATIVE],
        CHART_SENTIMENT_COLORS[SENTIMENT.NEUTRAL],
        CHART_SENTIMENT_COLORS[SENTIMENT.VERY_POSITIVE],
        CHART_SENTIMENT_COLORS[SENTIMENT.VERY_NEGATIVE],
      ],

      borderWidth: 0,
    });
  }

  const chartData = {
    labels: labels,
    datasets: datasets,
  };

  const options = pieOptions();

  return (
    <BaseWidget {...props} hasData={hasData(props.data)}>
      <Doughnut
        data={chartData}
        options={{
          ...options,
          ...eventPropsForPie(chartData, props, "sentiment"),
        }}
      />
    </BaseWidget>
  );
};

export { SentimentPieWidget };
